<template>
  <div>
    <template>
      <div style="width: 100%; position: relative; margin-bottom: 10px;">
        <div @click.stop="opened = !opened" style="width: 100%; overflow: auto; position: absolute; height: 35px;z-index: 1;opacity: 0;">
        </div>
        <select
          type="text"
          name="booking_extras"
          :class="'full-input ' + (computedMobile ? 'mobile-field' : '')"
        >
          <option style="color: gray">
            {{ selectedText }}
          </option>
        </select>
      </div>
    </template>
      <v-layout
        v-if="opened"
        wrap align-center
        class="elevation-5 popup-select-container booking-exras-container"
      >

        <v-flex xs12 text-xs-center>
          <v-layout
            wrap align-center
            style="border-bottom: 1px solid #ddd; padding-bottom: 5px; margin-bottom: 5px;"
          >
            <v-flex xs1 text-xs-center />
            <v-flex xs10 text-xs-center>
              <b>{{ $i18n.t('booking_extras') }}</b>
            </v-flex>
            <v-flex xs1 text-xs-right>
              <v-btn
               fab flat dark small
               class="form-close"
               @click="opened = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <template v-for="(bookingExtra, index) in bookingExtrasAllowed">
           <v-flex xs6>{{ bookingExtra['name_' + lang] }}</v-flex>
           <v-flex xs2 text-xs-right pr-3>{{ bookingExtra.price }} €</v-flex>

           <v-flex xs4 text-xs-center>
             <v-layout wrap align-center>
               <v-flex xs4 text-xs-right>
                 <v-btn
                  fab flat dark small outline
                  class="plus-minus-btn"
                  @click="remove(index)"
                 >
                   <v-icon small>fa-minus</v-icon>
                 </v-btn>
               </v-flex>
               <v-flex xs4 text-xs-center>{{ (bookingExtrasSelected && bookingExtrasSelected[index]) || 0 }}</v-flex>
               <v-flex xs4 text-xs-left>
                 <v-btn
                  fab flat dark small outline
                  class="plus-minus-btn"
                  @click="add(index)"
                 >
                   <v-icon small>fa-plus</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-flex>
        </template>
      </v-layout>
  </div>
</template>

<script>
import sharedComputed from './../views/sharedComputed'
import Vue from 'vue'
import api from './../api'
import helper from './../helper'
import moment from 'moment'
import sharedMethods from './../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'BookingFormExtras',

  components: {
  },

  data: () => {
    return {
      opened: false
    }
  },

  watch: {

  },

  computed: {
    ...sharedComputed,
    ...mapFields(Object.keys(state)),

    bookingExtrasAllowed () {
      return this.bookingExtras.filter(extra => {
        if (!extra.requiredFeature) { return true }
        const featureId = extra.requiredFeature.id
        const featurePresent = featureId && this.object.features && this.object.features[featureId]
        const featureActive = featurePresent && this.object.features[featureId].checked
        return featureActive
      })
    },

    selectedText () {
      let selectedText = this.bookingExtras.map((bookingExtra, index) => {
        if (this.bookingExtrasSelected[index]) {
          let count = this.bookingExtrasSelected[index]
          if (count > 0) {
            let nameField = count > 1 ? 'namePlural_' + this.lang : 'name_' + this.lang
            return this.bookingExtrasSelected[index] + ' ' + (bookingExtra[nameField] && bookingExtra[nameField].toLowerCase())
          }
          return null
        }
        return 0
      })
      .filter(name => name)
      .join(', ')

      return selectedText || this.$i18n.t('select')
    },

    computedMobile () {
      return this.mobile || this.sidebar || !this.showDesktopVersion
    }
  },

  props: {
    object: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  created () {
  },

  methods: {
    ...sharedMethods,

    add (index) {
      this.$store.dispatch('addBookingExtra', index)
    },

    remove (index) {
      this.$store.dispatch('removeBookingExtra', index)
    },
  }
}
</script>

<style>
.plus-minus-btn {
  height: 24px !important;
  width: 24px !important;
  color: #fac400 !important;
}
.form-check {
  height: 24px !important;
  width: 24px !important;
  color: #fac400 !important;
}
.form-close {
  height: 24px !important;
  width: 24px !important;
}
@media only screen and (max-width: 320px) {
  .booking-exras-container {
    font-size: 11px;
    padding: 8px !important;
  }
  .booking-exras-container .form-close {
    left: -10px;
  }
}
</style>
